import script from "./SidebarAddStream.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarAddStream.vue?vue&type=script&setup=true&lang=js"

import "./SidebarAddStream.vue?vue&type=style&index=0&id=b96fa094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96fa094"]])

export default __exports__